import { atom } from 'recoil';

export const chartMarginAtom = atom<'base' | 'small' | 'medium' | 'large'>({
	key: 'chartMargin',
	default: 'base',
});
